import { Alert, Button } from "flowbite-react";
import { useForm } from "react-hook-form";
import { ADMIN, COMPANY, LOAN } from "../../config/apiConfig";
import axios from "../../config/axiosInstance";
import { useEffect, useState } from "react";
import { useQuery } from "react-query";
import Input from "../inputs/Input";
import DrawerLoading from "../DrawerLoading";
import SelectInput from "../inputs/SelectInput";
import { normalizeText } from "../../utils/utils";
import CurrencyInput from "../inputs/CurrencyInput";
import CNPJInput from "../inputs/CNPJInput";
import PhoneInput from "../inputs/PhoneInput";
import { FaMagnifyingGlass } from "react-icons/fa6";
import PartnersInputList from "../inputs/PartnersInputList";

const CreateQueryForm = ({ fetchSimulations, onClose, isOpen }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoadingCompanyExternal, setIsLoadingCompanyExternal] =
    useState(false);
  const [key, setKey] = useState(0);
  const [error, setError] = useState(null);

  const { isLoading: isLoadingSegments, data: segmentsData } = useQuery(
    ["segments"],
    async () => {
      const { data } = await axios.get(LOAN.GET_SEGMENTS);
      return data.data;
    },
    { enabled: isOpen }
  );

  const {
    register,
    getValues,
    handleSubmit,
    reset,
    setValue,
    watch,
    control,
    formState: { errors },
  } = useForm({ shouldFocusError: false });

  const handleSearchCompanyExternal = async () => {
    try {
      setIsLoadingCompanyExternal(true);
      const rawDocument = getValues("company.document")?.replace(/\D/g, "");

      if (!rawDocument) {
        setError("Preencha o CNPJ corretamente antes de buscar.");
        return;
      }

      const { data: response } = await axios.get(
        `${COMPANY.GET_EXTERNAL_INFO}/${rawDocument}`
      );

      reset({
        company: {
          ...response.data.company,
          document: rawDocument,
        },
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoadingCompanyExternal(false);
    }
  };

  const selectedSegmentId = watch("credit.segmentId");
  const selectedSegment = segmentsData?.find(
    (segment) => segment.id === Number(selectedSegmentId)
  );
  const types = selectedSegment?.SegmentTypes || [];

  const onSubmit = async (data) => {
    setIsSubmitting(true);
    setError(null);
    try {
      console.log(data);
      await axios.post(`${LOAN.CREATE_NEW}`, data);

      onClose(false);

      fetchSimulations();
      reset();
    } catch (error) {
      setError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <form
        className="mb-6 flex flex-col gap-4"
        onSubmit={handleSubmit(onSubmit, (formErrors) => {
          console.warn("⛔ Erros de validação:", formErrors);
          setError("Preencha todos os campos obrigatórios.");
        })}
      >
        <div className="flex gap-2 items-center">
          <CNPJInput label="CNPJ *" name="company.document" control={control} />
          <Button
            className="py-2"
            onClick={handleSearchCompanyExternal}
            isProcessing={isLoadingCompanyExternal}
            disabled={isLoadingCompanyExternal}
          >
            <FaMagnifyingGlass />
          </Button>
        </div>
        <Input
          register={register}
          label="Razão Social *"
          name="company.socialReason"
          required
        />
        <Input
          type="email"
          register={register}
          label="E-mail *"
          name="company.email"
          required
        />
        <PhoneInput
          register={register}
          label="Telefone *"
          name="company.phoneNumber"
          control={control}
          required
        />
        <Input register={register} label="Endereço" name="company.address" />
        <Input
          register={register}
          label="Número"
          name="company.addressNumber"
        />
        <Input
          register={register}
          label="Bairro"
          name="company.addressNeighborhood"
        />
        <Input register={register} label="Cidade" name="company.addressCity" />
        <Input
          register={register}
          label="Nome Responsável *"
          name="company.responsibleName"
          required
        />
        <CurrencyInput
          register={register}
          label="Faturamento Mensal"
          name="company.incomeMonth"
          control={control}
        />
        <CurrencyInput
          register={register}
          label="Valor Desejado *"
          name="credit.amount"
          control={control}
        />

        <SelectInput
          register={register}
          name="credit.installments"
          label="Qtd. Parcelas *"
          required={true}
        >
          <option value="">Selecione a quantidade de parcelas</option>
          {Array.from({ length: 120 }, (_, i) => i + 1).map((num) => (
            <option key={num} value={num}>
              {num}x
            </option>
          ))}
        </SelectInput>

        <PartnersInputList control={control} register={register} />

        <SelectInput
          register={register}
          name="credit.segmentId"
          label="Segmento"
          required={true}
        >
          <option value="">Selecione o segmento</option>
          {segmentsData?.map((segment) => (
            <option key={segment.id} value={segment.id}>
              {segment.name}
            </option>
          ))}
        </SelectInput>

        <SelectInput
          register={register}
          name="credit.segmentTypeId"
          label="Tipo de crédito"
          required={true}
        >
          <option value="">Selecione o tipo</option>
          {types.map((type) => (
            <option key={type.id} value={type.id}>
              {type.name}
            </option>
          ))}
        </SelectInput>

        <Button
          className="primary py-2"
          type="submit"
          isProcessing={isSubmitting}
          disabled={isSubmitting}
        >
          Criar simulação
        </Button>
        {error && (
          <Alert withBorderAccent color="failure">
            Ops! Ocorreu um erro ao tentar criar uma nova consulta. Tente
            novamente mais tarde
          </Alert>
        )}
      </form>
      {isLoadingSegments && <DrawerLoading />}
    </>
  );
};

export default CreateQueryForm;
